import { Directive, TemplateRef } from '@angular/core';

/**
 * Direktive, um ein Template für die Darstellung von Tabellenzeilen (mit Daten) bereitzustellen.
 *
 * Das Template muss als Content des Tempaltes der Tabelle angegeben werden und sollte minimal wie folgt aussehen:
 *
 * ```
 *  <tr *tableDataRow="let row=row; let index=index; let columnsTemplate=columnsTemplate" class="tr"
 *      <ng-container *ngTemplateOutlet="columnsTemplate; context:{row, index}"></ng-container>
 *  </tr>
 * ```
 *
 * Das heißt also, es ist notwendig, für die Darstellung der Spalten selbst zu sorgen, indem das Template columnsTemplate genutzt wird.
 * Außerdem wird empfohlen, die CSS Klasse "tr" zu setzen, damit die im Theming festgelegten Styles für Tabellenzeilen greifen, es
 * sei denn, das ist nicht gewünscht. Es handelt sich dabei z.B. um abwechselnde Färbung der Zeilen und den Border zur Trennung der Zeilen,
 * aber auch um korrekte Textausrichtung.
 */
@Directive({ selector: '[tableDataRow]' })
export class TableDataRowDirective {
    constructor(public template: TemplateRef<any>) { }
}
